var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSupportQuestion = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.89543 0.895431 0 2 0H34C35.1046 0 36 0.895431 36 2V19C36 24.5228 31.5228 29 26 29H0V2Z",
    fill: "url(#paint0_linear_422_34149)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M16.2213 17.2358V16.4026C16.2213 15.8923 16.2968 15.4419 16.4479 15.0517C16.5991 14.6539 16.8416 14.2786 17.1757 13.9258C17.5098 13.5656 17.9512 13.1978 18.5 12.8225C18.9931 12.4923 19.3868 12.1958 19.6811 11.9331C19.9834 11.6704 20.2021 11.4115 20.3373 11.1563C20.4805 10.8936 20.5521 10.5971 20.5521 10.2669C20.5521 9.77903 20.3612 9.40751 19.9794 9.15232C19.5976 8.89713 19.0647 8.76954 18.3807 8.76954C17.6967 8.76954 17.0166 8.87086 16.3406 9.07351C15.6725 9.27616 14.9924 9.5426 14.3004 9.87285L13 7.40728C13.7954 6.98698 14.6584 6.64923 15.5889 6.39404C16.5195 6.13135 17.5376 6 18.6432 6C20.3453 6 21.6616 6.38653 22.5922 7.1596C23.5307 7.92517 24 8.90088 24 10.0868C24 10.7172 23.8926 11.2651 23.6779 11.7305C23.4711 12.1883 23.1529 12.6161 22.7234 13.0139C22.3019 13.4042 21.773 13.817 21.1367 14.2523C20.6594 14.5826 20.2936 14.8603 20.039 15.0854C19.7845 15.3106 19.6095 15.5358 19.5141 15.7609C19.4266 15.9786 19.3829 16.245 19.3829 16.5603V17.2358H16.2213ZM15.8395 21.0861C15.8395 20.3806 16.0423 19.8852 16.4479 19.6C16.8615 19.3148 17.3586 19.1722 17.9393 19.1722C18.504 19.1722 18.9892 19.3148 19.3948 19.6C19.8084 19.8852 20.0152 20.3806 20.0152 21.0861C20.0152 21.7616 19.8084 22.2494 19.3948 22.5497C18.9892 22.8499 18.504 23 17.9393 23C17.3586 23 16.8615 22.8499 16.4479 22.5497C16.0423 22.2494 15.8395 21.7616 15.8395 21.0861Z",
    fill: "#E5E4EC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 34.3258V29H13L1.4741 35.2063C0.807869 35.565 0 35.0825 0 34.3258Z",
    fill: "url(#paint1_linear_422_34149)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_422_34149",
    x1: 5.33333,
    y1: 4.53125,
    x2: 27.6636,
    y2: 37.3849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#928BB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E4EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_422_34149",
    x1: 1.92593,
    y1: 30.0937,
    x2: 6.29205,
    y2: 39.7039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#928BB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E4EC"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSupportQuestion);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/supportQuestion.bb74275082267327f7eb03bf29c53518.svg";